import { Injectable } from '@angular/core';
import { IZkuProfessional } from 'app/interfaces/professionalprofile.interface';
import { getBucket } from 'secchiojs';

@Injectable()
export class ZkuService {
	getZku: () => IZkuProfessional;
	setZku: (zku: IZkuProfessional) => void;
	removeZku: () => void;

	// Constructor.
	constructor() {
		const [getZku, setZku, removeZku] = getBucket<IZkuProfessional>('zku', {
			version: 7,
			defaultValue: null,
		});

		this.getZku = getZku;
		this.setZku = setZku;
		this.removeZku = removeZku;
	}
}
